import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress city path — permanently redirect to the /locations parent.
export const Route = createFileRoute("/location/paramus")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/new-jersey/paramus/", location.searchStr), statusCode: 301 });
  },
});
